import { dbApi, getApiErrorMessage } from "@/lib/api"
import type {
  CreateOrgUserRequest,
  InviteOrgUserResponse,
  OrgUser,
  UpdateOrgUserRequest,
} from "@/types/orgUser"

export async function listOrgUsers(): Promise<OrgUser[]> {
  const { data } = await dbApi.get<{ users: OrgUser[] }>("/api/org/users")
  return data.users
}

export async function getOrgUser(userId: string): Promise<OrgUser> {
  const { data } = await dbApi.get<{ user: OrgUser }>(`/api/org/users/${userId}`)
  return data.user
}

export async function createOrgUser(
  payload: CreateOrgUserRequest
): Promise<InviteOrgUserResponse> {
  const { data } = await dbApi.post<InviteOrgUserResponse>(
    "/api/org/users",
    payload
  )
  return data
}

export async function updateOrgUser(
  userId: string,
  payload: UpdateOrgUserRequest
): Promise<OrgUser> {
  const { data } = await dbApi.put<{ user: OrgUser }>(
    `/api/org/users/${userId}`,
    payload
  )
  return data.user
}

export async function deleteOrgUser(userId: string): Promise<void> {
  await dbApi.delete(`/api/org/users/${userId}`)
}

export { getApiErrorMessage }
